import { EmptyValuePlaceholder } from "@/components/ui"
import { formatDate, formatPrice } from '@/utils/formatters'

import { getFactureStatusLabel } from '../../../entretiens/entretiensSlice'

export default ({item}) => {
 
  return (
    <tr>
      <td>
        <EmptyValuePlaceholder value={item.entretien_type_nom} />
      </td>
      <td>{ item.prestataire?.nom_complet ? 
          item.prestataire?.nom_complet :
          <EmptyValuePlaceholder />
      }
      </td>
      <td>
        <EmptyValuePlaceholder value={formatDate(item.date_prestation)} />
      </td>
      <td><EmptyValuePlaceholder value={formatPrice(item.montant)}/></td>
      <td><EmptyValuePlaceholder value={getFactureStatusLabel(item.statut_facture)}/></td>
    </tr>
  )
}